import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-14 md:py-20 bg-primary-500">
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-background-50 mb-4">
          准备好开始使用免费91网页了吗？
        </h2>
        <p className="text-primary-100 text-base mb-8 max-w-xl mx-auto leading-relaxed">
          无需注册，即刻体验免费91网页的全部核心功能。安全、便捷、高效——一切尽在指尖。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/access-methods"
            className="w-full sm:w-auto px-8 py-3.5 bg-background-50 hover:bg-background-100 text-primary-600 font-semibold rounded-lg transition-all duration-200 text-base whitespace-nowrap cursor-pointer"
          >
            <i className="ri-links-line mr-2"></i>
            查看官方入口
          </Link>
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-600 hover:bg-primary-700 text-background-50 font-semibold rounded-lg border border-primary-400 transition-all duration-200 text-base whitespace-nowrap cursor-pointer"
          >
            <i className="ri-information-line mr-2"></i>
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}